import * as integrationConstants from './constants'
import { createSelector } from 'reselect'
import { Map } from 'immutable'

export const root = state => state.get('integrations')
export const connectionsRoot = state => state.getIn(['integrations', 'connections'])
export const connectionsFetchPending = state => state.getIn(['integrations', 'connectionsStatus']) === integrationConstants.FETCH_INTEGRATION_STATES_PENDING
export const connectionsUpdatePending = state => state.getIn(['integrations', 'connectionsStatus']) === integrationConstants.UPDATE_INTEGRATION_STATE_PENDING
export const isConnectedTo = (state, integrationName) => {
  return connectionsRoot(state) ? !!connectionsRoot(state)[integrationName] : false
}

export const connectionsFetched = createSelector(
  root,
  (root) => root.has('connections') && !_.isEmpty(root.get('connections'))
)

export const getEvents = (state, integrationType) => root(state).getIn(['events', integrationType, 'data'])
export const getPaginationQuery = (state, integrationType) => {
  const link = root(state).getIn(['events', integrationType, 'paginationLink'])
  return link ? link.split('/business/events/auth?')[1] : null
}

export const isLoaded = (state, integrationType) => root(state).getIn(['events', integrationType, 'status'], '') === integrationConstants.FETCH_INTEGRATION_EVENTS_SUCCESS

export const csvRequestSent = (state, integrationName) => root(state).getIn(['events', integrationName, 'status'], '') === integrationConstants.POST_BUSINESS_EVENT_CSV_SUCCESS

export const didCreateAccessToken = (state, integrationType) => root(state).getIn(['accessToken', integrationType, 'status']) === integrationConstants.CREATE_ACCESS_TOKEN_SUCCESS
export const failedCreateAccessToken = (state, integrationType) => root(state).getIn(['accessToken', integrationType, 'status']) === integrationConstants.CREATE_ACCESS_TOKEN_FAILED
export const accessTokenError = (state, integrationType) => root(state).getIn(['accessToken', integrationType, 'error'])

export const isGoogleAnalyticsConnected = (state) => {
  return state.getIn(['integrations', 'connections'], {})['googleAnalytics'] === true
}

const facebookSettings = state => root(state).get('facebookSettings', Map())
const facebookSettingsStatus = state => facebookSettings(state).get('status')
export const isFacebookSettingsPending = state => facebookSettingsStatus(state) === integrationConstants.FETCH_FACEBOOK_SETTINGS_PENDING
export const facebookSettingsData = state => facebookSettings(state).get('data', {})
export const facebookSettingsNeverFetched = state => facebookSettingsStatus(state) === undefined

const stripeKeys = state => root(state).get('stripeKeys', Map())
const stripeKeysStatus = state => stripeKeys(state).get('status')
export const isStripeKeysPending = state => stripeKeysStatus(state) === integrationConstants.FETCH_STRIPE_KEYS_PENDING
export const stripeKeysData = state => stripeKeys(state).get('data', {})
export const stripeKeysNeverFetched = state => stripeKeysStatus(state) === undefined

const outreachStatus = state => root(state).get('outreachStatus', Map())
export const isOutreachStatusPending = state => outreachStatus(state) === integrationConstants.FETCH_OUTREACH_STATUS_PENDING
export const isOutreachConnected = state => outreachStatus(state).getIn(['data', 'installed'], false)

export const getLeanDataAuthStatus = state => root(state).get('leanDataAuthStatus', Map())
export const getLeanDataAuthStatusPending = (state) =>
  getLeanDataAuthStatus(state).getIn(['leanDataAuthStatus', 'status']) === actions.getLeanDataAuthStatusPending.toString()




// WEBPACK FOOTER //
// ./src/scripts/app/modules/integrations/selectors.js